<template >
  <div style="padding:0;margin:0;">
    <v-chip title="Destinazione d'uso" class="ncChip" v-if="tipo == 'USO'" small color="bisque">{{ val }} </v-chip>
    <v-avatar color="blue" title="Locatario" size="22px" v-if="tipo == 'LOC'">
      <span class="white--text text-h5">L</span>
    </v-avatar>
    <v-avatar title="Proprietatio" color="orange" size="22px" v-if="tipo == 'PROP'">
      <span class="white--text text-h5">P</span>
    </v-avatar>
    <v-avatar title="Dati catastali" color="green" size="22px" v-if="tipo == 'DC'">
      <span class="white--text text-h5">C</span>
    </v-avatar>
  </div>
</template>
<script>
export default {
  name: "NcChip",
  props: {

    tipo: {
      type: String,
      required: true,
    },
    val: {
      type: String,
      required: true,
    },


    width: {
      type: String,
      required: false,
      default: "4rem",
    },

  },
  //props: ["rilievo","lpa","currentPrgComune","currentPrgAc"],

  data() {
    return {

    };
  },

  created() { },
  mounted() { },
  beforeMount() {

  },

  methods: {
  },
};
</script>
<style scoped>
.ncChip {
  font-weight: 600;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  font-size: 0.8rem;
  ;

  max-width: 4rem !important;
  ;

  border: 1px solid gray !important;
  ;
}
</style>